import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { CaseStudyDto, CaseStudyTagCategory, CaseStudyTagDto } from '@/types/case-studies';
const isOtherIndustry = (name: string) => {
  const lower = name.toLowerCase();
  return lower === 'other' || lower === 'others';
};
const collectTagNames = (cases: CaseStudyDto[], category: CaseStudyTagCategory): string[] => {
  const names = new Set<string>();
  cases.forEach(caseItem => {
    caseItem.tags?.forEach(tag => {
      if (tag.category === category && tag.name) names.add(tag.name);
    });
  });
  return Array.from(names);
};
const caseMatchesSelection = (tags: CaseStudyTagDto[] | undefined, category: CaseStudyTagCategory, selected: string[]) => {
  if (selected.length === 0) return true;
  return Boolean(tags?.some(tag => tag.category === category && selected.includes(tag.name)));
};
export const useCaseStudiesFiltering = cases => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedServices, setSelectedServices] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedIndustries, setSelectedIndustries] = useState(t1);
  let industries;
  let services;
  let t2;
  if ($[2] !== cases || $[3] !== selectedIndustries || $[4] !== selectedServices) {
    const validCases = cases.filter(_temp);
    services = collectTagNames(validCases, CaseStudyTagCategory.SERVICE).sort();
    industries = collectTagNames(validCases, CaseStudyTagCategory.INDUSTRY).sort(_temp2);
    t2 = selectedServices.length === 0 && selectedIndustries.length === 0 ? validCases : validCases.filter(caseItem => caseMatchesSelection(caseItem.tags, CaseStudyTagCategory.SERVICE, selectedServices) && caseMatchesSelection(caseItem.tags, CaseStudyTagCategory.INDUSTRY, selectedIndustries));
    $[2] = cases;
    $[3] = selectedIndustries;
    $[4] = selectedServices;
    $[5] = industries;
    $[6] = services;
    $[7] = t2;
  } else {
    industries = $[5];
    services = $[6];
    t2 = $[7];
  }
  const filteredCases = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (category, value) => {
      if (category === "service") {
        setSelectedServices(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
      } else {
        setSelectedIndustries(prev_0 => prev_0.includes(value) ? prev_0.filter(v_0 => v_0 !== value) : [...prev_0, value]);
      }
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const toggleFilter = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = category_0 => {
      if (category_0 === "service") {
        setSelectedServices([]);
      } else {
        setSelectedIndustries([]);
      }
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const clearFilters = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setSelectedServices([]);
      setSelectedIndustries([]);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const resetAllFilters = t5;
  let t6;
  if ($[11] !== filteredCases || $[12] !== industries || $[13] !== selectedIndustries || $[14] !== selectedServices || $[15] !== services) {
    t6 = {
      services,
      industries,
      selectedServices,
      selectedIndustries,
      filteredCases,
      toggleFilter,
      clearFilters,
      resetAllFilters
    };
    $[11] = filteredCases;
    $[12] = industries;
    $[13] = selectedIndustries;
    $[14] = selectedServices;
    $[15] = services;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(item) {
  return Boolean(item.cardPreview?.[0]);
}
function _temp2(a, b) {
  if (isOtherIndustry(a) === isOtherIndustry(b)) {
    return a.localeCompare(b);
  }
  return isOtherIndustry(a) ? 1 : -1;
}